import { render, staticRenderFns } from "./maskWrap.vue?vue&type=template&id=44251aee&scoped=true"
import script from "./maskWrap.vue?vue&type=script&lang=js"
export * from "./maskWrap.vue?vue&type=script&lang=js"
import style0 from "./maskWrap.vue?vue&type=style&index=0&id=44251aee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44251aee",
  null
  
)

export default component.exports